<template>
  <section class="request-document">
    <header class="header-layout">
      <mo-pageheader>
        <template slot="title" v-if="documents">{{ $t('title.requestDocument') }} : <span class="label" v-if="documents.length && !loading">{{ documentsCounter }}</span></template>
        <template slot="action">
          <div class="buttons-container flex">
            <ba-button class="primary" @click.native="$emit('close')">{{ $t('action.return') }}</ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <main class="main-layout">
      <!-- Loader -->
      <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>
      <!-- Table display -->
      <ba-table class="with-content" v-if="documents.length && !loading">
        <template slot="colgroup">
          <col>
          <col class="brand">
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
        </template>
        <template slot="body">
          <tr v-for="(document, index) in documents" :key="index">
            <td>
              <img :src="handleGetBrandImage(document.Aaa.brand)"  @error='defaultImage' />
            </td>
            <td class="brand-data">{{ document.Aaa.brand }} {{ document.Aaa.model }}<span class="subelement">{{ document.Aaa.energy }} - {{ document.Tecdoc.date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ document.Document.id }}</span></td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="motor in getType(document.Motor_type)">
                  {{ motor }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="gearbox in getType(document.Gearbox_type)">
                  {{ gearbox }}
                </li>
              </ul>
            </td>
            <td class="right">{{ document.Aaa.steam_power }}</td>
            <td class="right">{{ document.Aaa.fiscal_power }}</td>
            <td>{{ document.Aaa.gearbox }}<span class="subelement">{{ document.Aaa.gear_number }}</span></td>
            <td>{{ document.Document.view }} {{ document.Document.view == 1 ? `vue` : `vues` }}</td>
            <td>
              <ba-state-label
                :statut="getStatusColor(document.Document.status_document_label)"
                :label="document.Document.status_document_label"
                v-if="document.Document.status_document_label"
              >
              </ba-state-label>
              <!-- Get matchingDoc method from request mixin -->
              <mo-speedometer
                :defaultImg="`/img/request/speedometer-${getSpeedometerLabel(document.Document.note)}.png`"
                :hoverImg="'/img/request/speedometer-hover.png'"
                :value="document.Document.note"
                class="speedometer"
              ></mo-speedometer>

            </td>
            <td class="more filter-link flex">
              <div class="tooltip-container">
                <span class="item" @click="handleSelectDocument(document.Document.id)"><ab-icon class="associate" icon="associate"></ab-icon></span>
                <div class="tooltip">
                  {{ $t('action.select') }}
                </div>
              </div>
              
              <div class="tooltip-container">
                <span class="item" @click="moreDetails(document.Document.id)"><ab-icon icon="moreDetails"></ab-icon></span>
                <div class="tooltip">
                  {{ $t('action.moreDetails') }}
                </div>
              </div>
              
            </td>
          </tr>
        </template>
        <template slot="head">
          <tr>
            <th :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols" :key="index" @click="sortby(index)">
              <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon>
              </span>
            </th>
          </tr>
        </template>
      </ba-table>
      <div v-if="!documents.length && !loading">
        <p class="no-data">{{ $t('text.noDocumentsAvailable') }}</p>
      </div>
    </main>

    <footer class="footer-layout">
      <paginate
        :pageCount="pageCount(documents)"
        prev-class="prev"
        next-class="next"
        prev-text=" < "
        next-text=" > "
        v-model="currentPage"
        v-if="documents.length && !loading"
        :containerClass="'mo-pagination'">
      </paginate>
    </footer>

  </section>
</template>

<script>
import { AbIcon, BaButton, BaDropdown, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';
import MoLoader from '@/components/loader/mo-loader.vue';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import MoSpeedometer from '@/components/tool/mo-speedometer.vue';

import Paginate from 'vuejs-paginate';
import { mapState } from 'vuex';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import sortableMixin from '@/components/mixins/sortable.js';

export default {
  name: 'RequestDocument',
  components: {
    AbIcon,
    BaButton,
    BaDropdown,
    BaSelect,
    BaStateLabel,
    BaTable,
    MoLoader,
    MoPageheader,
    MoSpeedometer,
    Paginate
  },
  data() {
    return {
      documents: [],
      select1: '',
      select2: '',
      select3: '',
      select4: '',
      cols: [
        { label: '', sortable: false, sorted: '', key: '', class:'' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class:'' },
        { label: 'Type moteur', sortable: true, sorted: '', key: 'motor_type', class:'' },
        { label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_type', class:'' },
        { label: 'Puissance Ch.', sortable: true, sorted: '', key: 'aaa_steam_power', class:'right' },
        { label: 'Puissance Fis.', sortable: true, sorted: '', key: 'aaa_fiscal_power', class:'right' },
        { label: 'Boîte de vitesses', sortable: true, sorted: '', key: 'aaa_gearbox', class:'' },
        { label: 'Vues', sortable: true, sorted: '', key: 'view', class: '' },
        { label: 'Statut', sortable: true, sorted: '', key: 'status_document_label', class:'' },
        { label: '', sortable: false, sorted: '', key: '', class:'' },
      ],
    }
  },
  mixins: [ paginationMixin, requestMixin, sortableMixin ],
  props: {
    documentsProp: Array,
    documentsByKtype: Object,
    vehicle: Object
  },
  computed: {
    ...mapState({ loading: state => state.documents.loading }),
    documentsCounter() {
      if (this.documents.length) {
        const count = this.documents[0].counter;
        return `${count} fiche${count > 1 ? 's' : ''} article${count > 1 ? 's' : ''} trouvée${count > 1 ? 's' : ''}` ;
      }
    }
  },
  methods: {
    /* -- Modals -- */
    /* Select document to associate to the new request */
    handleSelectDocument(id) {
      this.$emit('selectDocument', id);
    },
    /* Display details for a document */
    moreDetails(id) {
      this.$emit('moreDocumentDetails', id);
    },
    /* -- Table actions -- */
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
    /* Get document motors & gearboxes */
    getType(array) {
      return array.map(e => e.label);
    },
    /* Returns ba-state-label color depending on its value */
    getStatusColor(status) {
      if (status == "Validé") return "success";
      else return "pending";
    },
    /* Get brand image */
    handleGetBrandImage(brand) {
      let text = brand.split(/[ -]+/)[0].toLowerCase();
      if (text == 'citroën') { text = 'citroen'; }
      if (text == 'vw') { text = 'volkswagen'; }
      if (text == 'land') { text = 'rover'; }
      if (text == 'bedford') { text = 'vauxhall'; }
      return `https://cdn.activcar.fr/media/64/brands/${text}.png`;
    },
    async getData() {
      this.$store.dispatch('setLoading', true);
      const data = await this.$store.dispatch('getDocumentsByKtype', {
        ...this.documentsByKtype,
        orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC', 'Document.id|ASC' ],
        doc_data: true
      });
      this.$store.dispatch('setLoading', false);
      if (!this.documents.length) {
        for (let doc of data) { this.documents.push({ ...doc, counter: data.length}); }
      }
    }
  },
};
</script>

<style scoped>
.request-document .speedometer {
  text-align: center;
  margin-top: 0.25rem;
}
</style>
<style src="@/assets/styles/tooltips.css"></style>
